import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDataset, DatasetSelect, Tabs, PageHead, CorteBadge } from "../lib/lm";
import { LoanTable } from "../components/lm/LoanTable";
import { LoanFicha } from "../components/lm/LoanFicha";
import { Completar } from "../components/lm/Completar";
import { Importador } from "../components/lm/Importador";
import { Cierres } from "../components/lm/Cierres";
import { Captacion } from "../components/lm/Captacion";

const TITULOS = { creditos: "Créditos", captacion: "Captación", completar: "Completar datos y cierres" };

export default function LoanManagement({ only, vista = "creditos" }) {
  const { info, ds, setDs } = useDataset();
  const [sp, setSp] = useSearchParams();
  const all = [["cartera", "Cartera"], ["completar", "Completar datos"], ["cierres", "Cierres mensuales"], ["captacion", "Captación"], ...(info?.admin ? [["importar", "Importar 5 tablas"]] : [])];
  const tabs = all.filter(([k]) => !only || only.includes(k));
  const [tab, setTab] = useState(tabs[0]?.[0] || "cartera");
  const loan = sp.get("loan");
  const lds = sp.get("dataset") || ds;
  return (
    <main className="mx-auto max-w-7xl space-y-6 px-4 py-8 sm:px-6 lg:px-10" data-testid="lm-page" style={{ animation: "rise .35s ease-out both" }}>
      <PageHead kicker="Cartera · Loan Management" title={TITULOS[vista] || "Loan Management"}><CorteBadge iso={info?.cortes?.[ds]} testid="lm-corte" /><DatasetSelect info={info} ds={ds} setDs={setDs} /></PageHead>
      {tabs.length > 1 && <Tabs tabs={tabs} tab={tab} setTab={setTab} />}
      {tab === "cartera" && <LoanTable ds={ds} key={`c-${ds}`} />}
      {tab === "completar" && <Completar ds={ds} key={`p-${ds}`} />}
      {tab === "cierres" && <Cierres ds={ds} key={`z-${ds}`} />}
      {tab === "captacion" && <Captacion />}
      {tab === "importar" && <Importador ds={ds} key={`i-${ds}`} admin={info?.admin} />}
      {loan && <LoanFicha ds={lds} id={loan} onClose={() => { sp.delete("loan"); sp.delete("dataset"); setSp(sp); }} />}
    </main>
  );
}
